module.exports = __webpack_public_path__ + "static/media/rating-star-average-icon.560325a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rating-star-average-icon.svg
// module id = 426
// module chunks = 0